import { render, staticRenderFns } from "./VerticalBlindSlatChoice.vue?vue&type=template&id=d31eaf84&scoped=true&"
import script from "./VerticalBlindSlatChoice.vue?vue&type=script&lang=js&"
export * from "./VerticalBlindSlatChoice.vue?vue&type=script&lang=js&"
import style0 from "./VerticalBlindSlatChoice.vue?vue&type=style&index=0&id=d31eaf84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d31eaf84",
  null
  
)

export default component.exports